import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { BatchPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { BATCH_ORGANIZER_TYPE } from "@academy-context/shared/domain/types/enums/batch-organizer-type";

export const retrieveTeacherBatchPaymentList = createAsyncThunk<BatchPaymentVM[], void, { extra: Partial<Dependencies> }>(
  "batchPayments/retrieveTeacherBatchPaymentList",
  async (_, { extra: { adminRepository } }) => {
    return adminRepository!.listBatchPayments(BATCH_ORGANIZER_TYPE.TEACHER);
  },
);

export const resetRetrieveTeacherBatchPaymentList = createAction("batchPayments/resetRetrieveTeacherBatchPaymentList");
